<template>
  <van-popup v-model="dialogVisible" round position="bottom">
    <div class="prompt-popup">
      <img class="swiper-close" src="@/assets/images/swiper-close.png" alt="" @click="dialogVisible = false" />
      <swiper :options="swiperOption" ref="mySwiper" class="swiper">
        <swiper-slide
          v-for="(item, i) in popupList"
          :key="i"
          class="swiper_item"
        >
          <div
            class="img"
            :style="{
              background: `url(${item.popupUrl})`,
              'background-size': '100% 100%',
            }"
          >
            <img
              class="carousel"
              :src="require(`@/assets/images/carousel-${i}.png`)"
              alt=""
            />
          </div>
        </swiper-slide>
      </swiper>
      <div class="popup-desc">
        <div class="desc-1">
          <span>请使用</span
          ><img src="@/assets/images/safari-for-mac.png" alt="" /><em>Safari</em
          ><span>浏览器打开链接</span>
        </div>
        <div class="desc-2">
          <span>安装</span
          ><img src="@/assets/images/ic_about_logo.png" alt="" /><em
            >万梦手游</em
          ><span>到桌面即可体验游戏</span>
        </div>
      </div>
      <div class="copy-link-btn" @click="copylink">复制链接</div>
    </div>
  </van-popup>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import copy from 'copy-to-clipboard';
export default {
  components: {
    swiper,
    swiperSlide,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    //定义这个swiper对象
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  data() {
    return {
      swiperOption: {
        effect: "coverflow",
        centeredSlides: true,
        spaceBetween: "11%",
        slidesPerView: "auto",
        loop: true,
        autoplay: true, // 是否自动播放
        touchRatio: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
      },
      popupList: [
        {
          popupUrl: require("@/assets/images/popup-swiper1.png"),
        },
        {
          popupUrl: require("@/assets/images/popup-swiper2.png"),
        },
        {
          popupUrl: require("@/assets/images/popup-swiper3.png"),
        },
      ],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {},
  methods: {
    copylink() {
      copy('https://ios.wmsy666.com/#/')
      this.$toast("已复制到剪切板！");
    }
  },
};
</script>

<style lang="scss">
.prompt-popup {
  .swiper-close {
    width: 48px;
    height: 48px;
    position: absolute;
    right: 30px;
    top: 20px;
    z-index: 999;
  }
  .swiper-container {
    width: 750px;
    height: 300px;
    // overflow: visible !important;
  }

  .swiper-wrapper .swiper-slide {
    width: 750px;
    height: 300px;
  }

  .swiper-wrapper .swiper-slide .img {
    position: relative;
    width: 750px;
    height: 300px;
    background-size: 100% 100%;
  }
  .carousel {
    width: 100px;
    height: 30px;
    position: absolute;
    bottom: 10px;
    left: 325px;
  }
  .popup-desc {
    margin-top: 40px;

    .desc-1,
    .desc-2 {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img {
      width: 50px;
      height: 50px;
    }

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 34px;
      color: #222222;
      line-height: 48px;
    }
    em {
      font-family: AlibabaPuHuiTi_2_65_Medium;
      font-size: 34px;
      color: #228bf2;
      line-height: 48px;
    }
    .desc-2 {
      margin-top: 12px;
      em {
        font-family: AlibabaPuHuiTi_2_65_Medium;
        font-size: 34px;
        color: #ff7a3e;
        line-height: 48px;
      }
    }
  }
  .copy-link-btn {
    margin: 0 auto;
    width: 670px;
    height: 100px;
    background: #ff7a3e;
    border-radius: 24px;
    font-family: AlibabaPuHuiTi_2_65_Medium;
    font-size: 34px;
    color: #ffffff;
    line-height: 100px;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/PromptPopup.vue